exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dashboard {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.dashboard img {\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n}\n.dashboard .header-img {\n  width: 100%;\n}\n.dashboard .wrap {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/container/dashboard/index.less
// module id = 74
// module chunks = 0